import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    CircularProgress,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import {
    fetchOpdSchedulePdfs,
    editOpdSchedulePdf,
    updateOpdSchedulePdf,
} from "../../Adapters/ApiAdapter";
import { baseImage_path } from "../../variables/Variables";

const ListOpdSchedulePdf = () => {
    const [pdfs, setPdfs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editItem, setEditItem] = useState(null);
    const [newFile, setNewFile] = useState(null);
    const [loadingAction, setLoadingAction] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            try {
                const response = await fetchOpdSchedulePdfs();
                setPdfs(response.data ? [response.data] : []);
            } catch (err) {
                toast.error("Failed to fetch OPD Schedule PDFs.");
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, []);

    const handleEdit = async (id) => {
        try {
            const res = await editOpdSchedulePdf(id);
            setEditItem(res.data);
        } catch (err) {
            toast.error("Failed to load PDF for editing.");
        }
    };

    const handleFileChange = (e) => {
        setNewFile(e.target.files[0]);
    };

    const handleSaveEdit = async () => {
        if (!newFile) return toast.error("Please upload a new PDF.");
        setLoadingAction(true);

        const formData = new FormData();
        formData.append("file_path", newFile);

        try {
            await updateOpdSchedulePdf(editItem.id, formData);
            toast.success("PDF updated successfully!");
            setEditItem(null);
            setNewFile(null);
            // Refresh list
            const updated = await fetchOpdSchedulePdfs();
            setPdfs(updated.data ? [updated.data] : []);
        } catch (err) {
            toast.error("Failed to update the PDF.");
        } finally {
            setLoadingAction(false);
        }
    };

    const columns = [
        { field: "id", headerName: "ID", width: 80 },
        {
            field: "file_path",
            headerName: "PDF File",
            flex: 1,
            renderCell: (params) =>
                params.row.file_path ? (
                    <a
                        href={`${baseImage_path}/${params.row.file_path.replace(/^\/|\\/g, "")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View PDF
                    </a>
                ) : (
                    "No File"
                ),
        },
        // {
        //     field: "source_page",
        //     headerName: "Source Page",
        //     flex: 1,
        //     renderCell: (params) => params.row.source_page || "N/A",
        // },
        // {
        //     field: "status",
        //     headerName: "Status",
        //     width: 100,
        //     renderCell: (params) => params.row.status || "N/A",
        // },
        {
            field: "created_at",
            headerName: "Created At",
            width: 180,
            renderCell: (params) =>
                new Date(params.row.created_at).toLocaleString("en-IN"),
        },
        {
            field: "updated_at",
            headerName: "Updated At",
            width: 180,
            renderCell: (params) =>
                new Date(params.row.updated_at).toLocaleString("en-IN"),
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 150,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleEdit(params.row.id)}
                >
                    Edit
                </Button>
            ),
        },
    ];


    return (
        <Box m="20px">
            <ToastContainer />
            <Typography variant="h4" gutterBottom>
                OPD Schedule PDF List
            </Typography>

            {loading ? (
                <CircularProgress />
            ) : (
                <DataGrid
                    rows={pdfs}
                    columns={columns}
                    getRowId={(row) => row.id}
                    autoHeight
                />
            )}

            {editItem && (
                <Dialog open onClose={() => setEditItem(null)} maxWidth="sm" fullWidth>
                    <DialogTitle>Edit OPD Schedule PDF</DialogTitle>
                    <DialogContent>
                        <Typography>
                            Current File:{" "}
                            <a
                                href={`${baseImage_path}/${editItem.file_path}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View PDF
                            </a>
                        </Typography>
                        <input
                            type="file"
                            accept="application/pdf"
                            onChange={handleFileChange}
                            style={{ marginTop: "20px" }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={() => setEditItem(null)}
                            style={{ backgroundColor: "#ccc" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSaveEdit}
                            disabled={loadingAction}
                        >
                            {loadingAction ? <CircularProgress size={20} /> : "Update"}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </Box>
    );
};

export default ListOpdSchedulePdf;